import { db } from '../firebaseInit'

export default {
  state: {
    leadsList: [],
    convertedLeads: []
  },
  mutations: {
    updateEditedNote (state, payload) {
      state.leadsList[payload.index].notes = payload.notes
    },
    updateLead (state, payload) {
      state.leadsList[payload.index] = { ...state.leadsList[payload.index], ...payload.data }
    },
    newLead (state, payload) {
      state.leadsList.push(payload)
    },
    getLeads (state, payload) {
      state.leadsList = payload
    },
    convertedLeads (state, payload) {
      state.convertedLeads = payload
    }
  },
  actions: {
    convertedLeads ({commit}) {
      let leadList = []
      db.collection('contacts').where('deleted', '==', false).get().then(contacts => {
        contacts.forEach(contact => {
          if (contact.data().opportunities && contact.data().opportunities.length > 0) {
            contact.data().opportunities.forEach(opp => {
              if (opp.deleted !== true && opp.closed_date && opp.status === 'Closed - Won') {
                let name = null
                if (contact.data().secondaryContact_first_name) {
                  name = contact.data().first_name + ' ' + contact.data().last_name + ' and ' + contact.data().secondaryContact_first_name + ' ' + contact.data().secondaryContact_last_name
                } else {
                  name = contact.data().first_name + ' ' + contact.data().last_name
                }
                leadList.push({name: name, id: contact.id, contract_amount: opp.contract_amount, sales_rep: opp.sales_rep, source: opp.source, closed_date: opp.closed_date, created_date: opp.created_date})
              }
            })
          }
        })
      }).then(() => {
        commit('convertedLeads', leadList)
      })
    },
    addNewOpportunity ({commit, dispatch, getters}, payload) {
      let opps = []
      let preOpps = []
      db.collection('contacts').doc(payload.contact.id).get().then(contact => {
        if (contact.data().opportunities) {
          opps = contact.data().opportunities
        }
        preOpps = contact.data().opportunities ? contact.data().opportunities : null
        opps.push(payload.opportunity)
      }).then(() => {
        db.collection('contacts').doc(payload.contact.id).update({opportunities: opps, ifOppsPhase: true})
        const logData = { timestamp: new Date(), collection: 'contacts', type: 'add', user_id: getters.user.id, record_id: payload.contact.id, changed_from: { opportunities: preOpps }, changed_to: { opportunities: opps }, message: getters.user.first_name + '  added new opportunity to the lead: ' + payload.contact.last_name + ', ' + payload.contact.first_name, icon: 'person_outline' }
        dispatch('commitLog', logData)
      })
    },
    sendProjectToLeads ({commit, dispatch, state, getters}, payload) {
      // Get All Opportunities - Find Index of Correct One - Make Changes
      let contact = null
      let oppIndex = null
      db.collection('contacts').doc(payload.contact.id).get().then(queryContact => {
        contact = queryContact.data()
        if (contact.opportunities && contact.opportunities.length > 0) {
          contact.opportunities.forEach((opp, i) => {
            if (opp.project === payload.project.id) {
              oppIndex = i
            }
          })
        } else { // If no opp record exists create one
          if (!payload.project.sales_rep) { // If Sales_Rep is missing, assign to Wes - For older records not coming from leads.
            payload.project.sales_rep = 'aIiPcjJ6vKNiBH0vbVQ6AGuuP2t2'
          }
          if (!contact.created_date) {
            contact.created_date = payload.project.start_date
          }
          contact.opportunities = [ payload.project ]
          contact.opportunities[0].created_date = payload.project.start_date
          contact.type = 'Lead'
          contact.status = 'New Lead'
          oppIndex = 0
        }
        const project = payload.project
        let oppChanges = { address: project.address, budget_max: project.budget_max, budget_min: project.budget_min, builder: project.builder, builder_contact: project.builder_contact, building_dept: project.building_dept, city: project.city, contract_amount: project.contract_amount, description: project.description, financing: project.financing, gate_code: project.gate_code, hoa: project.hoa, other_designs: project.other_designs, property_survey: project.property_survey, state: project.state, zip: project.zip }
        contact.opportunities[oppIndex] = {...contact.opportunities[oppIndex], ...oppChanges, active: true, revertedToLeads: payload.project.id, status: 'In Progress'}
      }).then(() => {
        db.collection('contacts').doc(payload.contact.id).update({ opportunities: contact.opportunities }).then(() => {
          db.collection('projects').doc(payload.project.id).update({ revertedToLeads: true }).then(() => {
            const logContactData = { timestamp: new Date(), collection: 'contacts', type: 'edit', user_id: getters.user.id, record_id: payload.contact.id, changed_from: { status: 'Closed - Won', type: payload.contact.type }, changed_to: { status: 'New Lead', type: 'Lead', revertedToLeads: payload.project.id }, message: getters.user.first_name + '  reverted the project ' + payload.project.name + ' back to the lead: ' + payload.contact.last_name + ', ' + payload.contact.first_name, icon: 'person_outline' }
            dispatch('commitLog', logContactData)
            const logProjectData = { timestamp: new Date(), collection: 'projects', type: 'edit', user_id: getters.user.id, record_id: payload.project.id, changed_from: { revertedToLeads: false }, changed_to: { revertedToLeads: true }, message: getters.user.first_name + '  reverted the project ' + payload.project.name + ' back to the lead: ' + payload.contact.last_name + ', ' + payload.contact.first_name, icon: 'person_outline' }
            dispatch('commitLog', logProjectData)
            dispatch('newLead', {...payload.contact, status: 'New Lead', type: 'Lead', revertedToLeads: payload.project.id})
          })
        })
      })
    },
    updateEditedNote ({commit, state}, payload) {
      const index = state.leadsList.findIndex(i => i.id === payload.id)
      commit('updateEditedNote', {index, notes: payload.notes})
    },
    newLead ({ commit }, payload) {
      commit('newLead', payload)
    },
    sendNotesFromContact ({ commit }, payload) {
      payload.notes.forEach(note => {
        db.collection('projects').doc(payload.projectId).collection('notes').add(note).then(() => {
        })
      })
    },
    restoreProject ({ commit, dispatch, state, getters }, payload) {
      const leadIndex = state.leadsList.findIndex(i => i.id === payload.contactId)
      let projectNotes = []
      let newNotes = []
      db.collection('contacts').doc(payload.contactId).update({opportunities: payload.update}).then(() => {
        commit('updateLead', { data: payload.update, index: leadIndex })
        db.collection('projects').doc(payload.projectData.projectId).update(payload.projectData).then(() => {
          // Add Applicable Notes
          db.collection('projects').doc(payload.projectData.projectId).collection('notes').where('deleted', '==', false).get().then(query => {
            query.forEach(note => {
              projectNotes.push(note.data().note)
            })
            payload.notes.forEach(note => {
              if (projectNotes.includes(note.note)) { // Avoids note duplication from PREVIOUS lead notes.
              } else {
                newNotes.push(note)
              }
            })
            newNotes.forEach(note => {
              db.collection('projects').doc(payload.projectData.projectId).collection('notes').add(note).then(() => {
              })
            })
          })
          // Write to Logs
          const logData = { timestamp: new Date(), collection: 'contacts', type: 'edit', user_id: getters.user.id, record_id: payload.contactId, changed_from: payload.log.changedFrom, changed_to: payload.log.changedTo, message: getters.user.first_name + ' ' + payload.logMessage + ' ' + payload.log.changedTo + ' for the lead ' + payload.contactName, icon: 'person_outline' }
          dispatch('commitLog', logData)
          const logProjectData = { timestamp: new Date(), collection: 'projects', type: 'edit', user_id: getters.user.id, record_id: payload.projectData.projectId, changed_from: {}, changed_to: payload.projectData, message: getters.user.first_name + ' restored the project for the lead ' + payload.contactName, icon: 'person_outline' }
          dispatch('commitLog', logProjectData)
        })
      })
    },
    updateLead ({ commit, dispatch, state, getters }, payload) {
      const leadIndex = state.leadsList.findIndex(i => i.id === payload.contactId)
      db.collection('contacts').doc(payload.contactId).update(payload.update).then(() => {
        commit('updateLead', { data: payload.update, index: leadIndex })
        if (payload.refresh && payload.refresh === true) {
          dispatch('getLeads', {user: payload.user, showInactive: payload.showInactive})
        }
        const logData = { timestamp: new Date(), collection: 'contacts', type: 'edit', user_id: getters.user.id, record_id: payload.contactId, changed_from: payload.log.changedFrom, changed_to: payload.log.changedTo, message: getters.user.first_name + ' ' + payload.logMessage + ' ' + payload.log.changedTo + ' for the lead ' + payload.contactName, icon: 'person_outline' }
        dispatch('commitLog', logData)
      })
    },
    getLeads ({ commit }, payload) { // payload: {user: this.user.id, showInactive: false}
      let leads = []
      let queryString = null
      queryString = db.collection('contacts').where('deleted', '==', false)
      queryString.get().then(query => {
        query.forEach(lead => {
          const allOpps = lead.data().opportunities
          if (lead.data().opportunities) {
            lead.data().opportunities.forEach((opp, i) => {
              if (opp.status !== 'Closed - Won') {
                leads.push({ ...lead.data(), id: lead.id, opportunities: {...opp, index: i}, allOpps: allOpps })
              }
            })
          }
        })
      })
        .catch(error => console.log('Error getting leads from database. Error: ', error))
        .then(() => {
          commit('getLeads', leads)
        })
    }
  },
  getters: {
    leads (state) {
      return state.leadsList
    },
    convertedLeads (state) {
      return state.convertedLeads
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/leads.js